import styled from 'styled-components';
import ContentEditable from 'react-contenteditable';

import {
  Flex,
  icons,
} from 'web-styled';

export const Video = styled(Flex).attrs({
  column: true,
  fillSpace: true,
})`
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #ffffff;
  overflow: hidden;

  &:hover {
    background: #fbfbfb;
  }
`;

export const Preview = styled(Flex).attrs({
  spacing: 10,
  column: true,
  align: 'center',
  justify: 'center',
})`
  height: 64%;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
`;

export const Frame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background: none;
`;

export const PlayIcon = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  cursor: pointer;
  height: 44px;
  width: 44px;
  background-color: rgba(255,255,255,0.7);
  border-radius: 44px;
  overflow: hidden;

  svg {
    width: 15px;
    height: 15px;
    fill: ${props => props.theme.colors.primary};
  }
`;

export const Icon = styled.span`
  height: 11px;
  width: 11px;
  background-size: cover;
  background-image:  url(${icons.videoTime});
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: right 0;
`;

interface EdnitableProps {
  disabled: boolean;
}

export const EditableName = styled(ContentEditable) <EdnitableProps>`
  color: ${props => props.theme.colors.inputColor};
  font-size: 14px;
  line-height: 14px;
  outline: none;
  width: 100%;

  ${props => !props.disabled && `
    padding: 5px 5px;
    margin-left: -5px;
    border: 1px dashed transparent;
    border-radius: 5px;

    &:hover,
    &:focus {
      border-color: ${props.theme.colors.primary};
    }
  `};
`;
